// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__ce4pF","add_button":"Dashboard_add_button__2rtD1","plus_icon":"Dashboard_plus_icon__zRt0r"};